<script>

    import {Router, RootLayout} from "@intellectability/platform-common/router";

    import routerConf from "./router.js";

    import {isLoggedIn} from "@intellectability/platform-common/sv/state";

</script>

<RootLayout>
    <Router routerConfig={routerConf} isLoggedIn={$isLoggedIn}></Router>
</RootLayout>